import React, { Component } from "react";
import NotificationAdmin from "./NotificationAdmin";
import NotificationPackAdmin from "./NotificationPackAdmin";

export default class NotificationAdminSelector extends Component {
  state = {
    view: "Notification",
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container">
            <h1>Notifikation Admin</h1>
            <p>
              OBS: Hvis du ændrer en notifikationspakke vil det først træde i
              kraft når du gemmer KAMPAGNEN.
              <br />
              Hvis du ændrer enkelte notifikationer, vil de være ændret med det
              samme. De bliver sendt ud, som de står i kontrolpanelet.
            </p>
            <br />
            <button
              style={{
                fontSize: "20px",
                border:
                  this.state.view == "Notification" ? "3px solid #5dab71" : "",
                color: this.state.view == "Notification" ? "#5dab71" : "",
                background: "white",
                borderRadius: "12px",
                padding: "5px 10px",
              }}
              onClick={() => {
                this.setState({ view: "Notification" });
              }}
            >
              Notifikationer
            </button>
            <button
              style={{
                fontSize: "20px",
                border:
                  this.state.view == "Notificationpack"
                    ? "3px solid #5dab71"
                    : "",
                color: this.state.view == "Notificationpack" ? "#5dab71" : "",
                marginLeft: "10px ",
                background: "white",
                borderRadius: "12px",
                padding: "5px 10px",
              }}
              onClick={() => {
                this.setState({ view: "Notificationpack" });
              }}
            >
              Notifikationspakker
            </button>
            <br />
            {this.state.view == "Notification" ? (
              <NotificationAdmin />
            ) : (
              <NotificationPackAdmin />
            )}
          </div>
        </section>
      </>
    );
  }
}
